import template from './subcontractors.html';
import controller from './subcontractors.controller';

let subcontractorsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default subcontractorsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontractors/subcontractors.component.js